import { useQuery } from '@tanstack/react-query';

export const usePriceStream = () => {
  return useQuery({
    queryKey: getKey(),
    queryFn: fetcher,
    staleTime: Infinity,
    retry: 5,
  });
};
const getKey = () => {
  return ['benchmark', 'stream'];
};
const fetcher = async () => {
  const stream = await fetch(
    'https://benchmarks.pyth.network/v1/shims/tradingview/streaming',
  );

  if (!stream.ok) {
    throw new Error('Failed to fetch stream');
  }

  const reader = stream.body?.getReader();

  return reader;
};
usePriceStream.getKey = getKey;
usePriceStream.fetcher = fetcher;
